import moment from 'moment';
import { finishTx } from '../../actions/purchaseActions';
import { triggerError } from '../../actions/maintenanceActions';
import { goLoading, outLoading } from '../../actions/loadingActions';
import { setLightStat, lightOff } from '../../actions/lightActions';

import { Loading as i18n, Errors as i18nErrors } from '../i18n';

export default function printerMM(action, store, _hub, next){

  switch(action.type){

    case 'PRINT_RECEIPT':
      store.dispatch(setLightStat("RPS"))
      let lang = store.getState().i18n.language.current
      store.dispatch(goLoading(i18n[lang].printing))
      if(store.getState().machine.name === 'rick'){
        console.log(action.content)
        _hub.server.cS_RPS_PrintHtml(action.content).done(response=>{
          setTimeout(() => store.dispatch(finishTx()), 2000)
          // store.dispatch(outLoading('finish-screen'));
          console.log(response)
          store.dispatch(lightOff("RPS"))
        })
        .fail(error=>{
          console.log(error)
        })
      }
      break;

    case 'PRINT_CLEAR_CASH':
      _hub.server.cS_RPS_PrintHtml(action.report).done(response=>{
      })
      break;

    default:
      next()
  }
}